class Validate {
	static isEmail(email) {
		let pattern = /(^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)+$)/gi;
		return pattern.test(email);
	}

	static isPassword(passwd) {
		//let pattern =/((?=.*\d)(?=.*[a-zA-Z]).{6,20})/g;  // <-- pattern from the internet
		// better pattern for password  (?<!(\S|\s))(?=.*\d)(?=.*[a-zA-Z])(?=.*[$!%&*]).{6,20}(?!(\S|\s))
		// <-- this pattern looks for anything before and after the max 20 and fails to match if there is more than 20
	
		// let pattern = /(?<!(\S|\s))(?=.*\d)(?=.*[a-zA-Z])(?=.*[$!%&*]).{6,20}(?!(\S|\s))/g; // <- safari browser can't do negative lookahead
		// let pattern = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[$!%@&#*%^?])[\S]{6,20}$/g;
		let pattern = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&*(){}\-_=+\[\];:\'\"\\,<.>|/?])[\S]{6,20}$/g;
		return pattern.test(passwd);
	}

	constructor(form, actionButton, checkChanges) {
		this._validationFields = [];
		this._changeFields = [];
		this._warnings = [];
		this._failCount = 0;
		this._changeCount = 0;
		this._button = false;
		this._checkChanges = checkChanges || false;

		for(let elem of form.elements) {
			if (elem.hasAttribute('data-prev')) {
				this._changeFields.push(elem);
			}
			if (elem.hasAttribute('data-validate')){
				this._validationFields.push(elem);
				this._warnings.push(null);

				onEv(elem, 'blur', () => {
					elem.warn = true;
				});

				if (elem.type == 'checkbox' || elem.type == 'select-one') {
					onEv(elem, 'change', this.validate.bind(this));
				} else {
					onEv(elem, 'keyup paste blur', this.validate.bind(this));
				}
			}
		}
		if (actionButton) this.primeButton(actionButton);
	}

	primeButton(button) {
		this._button = button;
		onEv(this._button, 'mousedown touchstart', this.disarm.bind(this));
		this.validate();
	}

	releaseButton() {
		remEv(this._button, 'mousedown touchstart', this.disarm.bind(this));
		this._button = false;
	}

	disarm() {
		this._validationFields.forEach((f) => f.warn = false);
	}
	
	updateButton() {
		this._button.disabled = 0 < this._failCount || (this._checkChanges && this._changeCount == 0);
	}

	reset() {
		for (let e of this._validationFields) e.valid = this.check(e);
		this.disarm();
		this.validate();
	}

	validate() {
		if (!this._button) return;
		this._failCount = 0;
		this._changeCount = 0;
		for (let field of this._validationFields) this.check(field);
		for (let field of this._changeFields) this.changed(field);
		this.updateButton();
	}

	changed(f) {
		if (f.type == 'checkbox') {
			if (!!f.getAttribute('data-prev') != !!f.checked) this._changeCount++;
		}
		else {
			if (f.getAttribute('data-prev') != f.value) this._changeCount++;
		}
	}

	check(field) {
		for (let test of field.getAttribute('data-validate').split(' ')) {
			let result = this.test(field, test);
			if (result != null) {
				this.showWarning(field, result);
				return;
			}
		}
		this.clearWarning(field);
	}

	test(field, test) {
		switch (test) {
			case 'required': return this.required(field);
			case 'name': return this.name(field);
			case 'reqWithoutUsername': return this.reqWithoutUsername(field);
			case 'email': return this.emailFormat(field);
			case 'uniqueEmail': return this.uniqueEmail(field);
			case 'reqWithoutEmail': return this.reqWithoutEmail(field);
			case 'username': return this.username(field);
			case 'uniqueUsername': return this.uniqueUsername(field);
			case 'password': return this.password(field);
		}
	}

	required(field) {
		if (field.value.length) return null;

		return field.getAttribute('aria-label') + _(' is required');
	}

	name(field) {
		let na = field.value.trim().split(' ');
		
		if (Array.isArray(na) && na.length > 1) return null;
		return 'Please enter first and last name';
	}

	emailFormat(field) {
		this._validEmail = false;
		if (field.value.length == 0) return null;
		if (Validate.isEmail(field.value)) {
			this._validEmail = true;
			return null;
		}
		
		return 'Email address is invalid';
	}

	reqWithoutUsername(field) {
		if (field.value.length || this._validUsername) return null;

		return 'Email address is require if no username';
	}
	
	uniqueEmail(field) {
		this._validEmail = false;
		if (field.value.length == 0) return null;
		if (field.hasAttribute('data-prev') && field.getAttribute('data-prev') == field.value) {
			this._validEmail = true;
			return null;
		}
		if (!Validate.isEmail(field.value)) return 'Email address is invalid';
	
		this._validEmail = true;
		if (field.value === this._lastEmailChecked) return this._lastEmailError;
		this._lastEmailChecked = field.value;
		this._lastEmailError = null;
		API.fetch('validate/', {
			'field': 'email',
			'value': field.value
		})
		.then(reply => {
			if (reply.error) {
				this._validEmail = false;
				this._lastEmailError = reply.error;
				this.showWarning(field, reply.error);
			}
			else {
				this._lastEmailError = null;
				this.clearWarning(field);
			}
			this.updateButton();
		})
		return null;
	}
	
	usernameFormat(value) {
		if (value.length < 6) return 'Usernames must be a least 6 characters long';
		if (/\s/.test(value)) return 'Usernames must not contain spaces';
		return true;
	}

	reqWithoutEmail(field) {
		if (field.value.length || this._validEmail) return null;

		return 'Username is required if no email address';
	}

	username(field) {
		this._validUsername = false;
		if (field.value.length == 0) return null;
		let res = this.usernameFormat(field.value);
		if (res !== true) return res;
		this._validUsername = true;
		return null;
	}

	uniqueUsername(field) {
		this._validUsername = false;
		if (field.value.length == 0) return null;
		if (field.hasAttribute('data-prev') && field.getAttribute('data-prev') == field.value) {
			this._validUsername = true;
			return null;
		}

		let res = this.usernameFormat(field.value);
		if (res !== true) return res;

		this._validUsername = true;
		if (field.value === this._lastUsernameChecked) return this._lastUsernameError;
		this._lastUsernameChecked = field.value;
		this._lastUsernameError = null;
		API.fetch('validate/', {
			'field': 'username',
			'value': field.value
		})
		.then(reply => {
			if (reply.error) {
				this._validUsername = false;
				this._lastUsernameError = reply.error;
				this.showWarning(field, reply.error);
			}
			else {
				this._lastUsernameError = null;
				this.clearWarning(field);
			}
			this.updateButton();
		})
		return null;
	}

	password(field) {
		if (field.value.length == 0) return null;
		if (Validate.isPassword(field.value)) return null;

		return '6 to 20 characters with letter, numbers and symbols';
	}

	showWarning(elem, message) {
		this._failCount++;

		if (!elem.warn) return;

		let i = this._validationFields.indexOf(elem);
		if (this._warnings[i] == null) {
			this._warnings[i] = UI.div('form-warning', message);
			elem.parentNode.insertBefore(this._warnings[i], elem);
		}
		else {
			this._warnings[i].innerText = message;
		}

		state(elem, 'warn');
	}

	clearWarning(elem) {
		let i = this._validationFields.indexOf(elem);
		if (this._warnings[i] != null) {
			this._warnings[i].remove();
			this._warnings[i] = null;
		}
	}
}